import React from "react";
import { Col, Row, Card } from "antd";
import lims from "../images/lims.svg";
import { TryProduct } from "./TryTheProduct";

interface userProp { currentUser: any; }

const Lims: React.FC<userProp> = ({ currentUser }) =>  {

  return (
    <Card hoverable bodyStyle={{width: '100%'}} className={currentUser ? "product-layout product-layout-logged" : "product-layout"}>
      <div >
      <Row>
        <Col>
        <div className="product-description-img lims">
          <div className="product-img-border">
            <img
              className="product-img"
              src={lims}
              height="100%"
              alt="scientia-image"
            />
          </div>
        </div>
        </Col>
        </Row>
        <p className="eyebrow-text">Streamline your metadata management</p>
        <h2 className="h2 h2-lims">LIMS</h2>
        <p className="p" style={{width: '100%'}}>
        Easy, secure, and scaleable way to manage and integrate metadata with laboratory information system.
        </p>
        <p className="product-button">Submit Metadata
          <TryProduct />
          </p>
      </div>
    </Card>
  );
};

export default Lims;
